// CardDataContext.js
import React, { createContext, useContext, useState } from 'react';

const CardDataContext = createContext();

export const useCardDataContext = () => {
  const context = useContext(CardDataContext);
  if (!context) {
    throw new Error('useCardDataContext must be used within a CardDataProvider');
  }
  return context;
};

export const CardDataProvider = ({ children }) => {
  const [cardCount, setCardCount] = useState(0);
  const [blogMetaData, setBlogMetaData] = useState([
    { id: '', title: '', slugTitle: '' },
    // Add more objects as needed
  ]);

  

  const updateBlogMetaData = (newData) => {
    setBlogMetaData(newData);
  };


  const updateCardCount = (newCount) => {
    setCardCount(newCount);
  };

  return (
    <CardDataContext.Provider value={{ cardCount, updateCardCount,blogMetaData,setBlogMetaData }}>
      {children}
    </CardDataContext.Provider>
  );
};
